import React from "react";
import InlineSVG from "react-inlinesvg";

interface ISvgProps {
  src: string;
  className?: string;
  onLoad?: (src: string | URL) => void;
}

const SVG: React.FC<ISvgProps> = ({ src, className, onLoad }) => {
  // @HACK(blambo, 2019-07-26): To allow SVG icons to load properly on the static S3 hosted storybook, we need to change
  // Asset paths from absolute to relative
  if (window.location && window.location.hostname.includes("qwilr-storybook.s3") && src.indexOf("/Assets") === 0) {
    src = `.${src}`;
  }

  // Don't attempt to render anything during a test
  if (process.env.NODE_ENV === "test") {
    return null;
  }

  return (
    <InlineSVG src={src} className={className} onLoad={onLoad} loader={<span className={className} />}>
      <img aria-hidden className={className} src={src} />
    </InlineSVG>
  );
};

export default SVG;
